import { cn } from "@/lib/utils";

interface WheelButtonIconProps extends React.SVGProps<SVGSVGElement> {
  className?: string;
}

export const WheelButtonIcon = ({ className, ...props }: WheelButtonIconProps) => (
  <svg
    width="24"
    height="24"
    viewBox="0 0 24 24"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
    className={cn("h-6 w-6", className)}
    aria-label="Spinning Wheel"
    role="img"
    {...props}
  >
    <path
      fill="currentColor"
      d="M17.975 1.594a.797.797 0 0 0-1.092.294.798.798 0 0 0 .294 1.092A10.446 10.446 0 0 1 22.401 12c0 5.733-4.667 10.4-10.401 10.4S1.6 17.733 1.6 12c0-3.707 2.001-7.163 5.222-9.02a.8.8 0 0 0-.798-1.387A12.047 12.047 0 0 0 0 12c0 6.618 5.383 12.001 12 12.001 6.618 0 12.002-5.383 12.002-12 0-4.278-2.31-8.265-6.026-10.406Z"
    />
    <path
      fill="currentColor"
      d="M3.312 12c0 4.785 3.898 8.68 8.688 8.68 4.79 0 8.689-3.895 8.689-8.68a8.721 8.721 0 0 0-4.317-7.507.8.8 0 1 0-.806 1.38 7.082 7.082 0 0 1 2.125 1.918l-4.89 2.824V9.133a.8.8 0 1 0-1.6 0v1.482L6.31 7.791a7.082 7.082 0 0 1 2.125-1.917.8.8 0 1 0-.806-1.381 8.722 8.722 0 0 0-4.317 7.506Zm3.003 4.21 4.885-2.822v5.644a7.085 7.085 0 0 1-4.885-2.823Zm6.485 2.82v-5.643l4.885 2.822a7.08 7.08 0 0 1-4.885 2.822ZM19.088 12a7.03 7.03 0 0 1-.594 2.829L13.6 12l4.89-2.824c.384.88.598 1.837.598 2.822ZM10.4 12l-4.895 2.826A7.02 7.02 0 0 1 4.911 12c0-.985.214-1.942.598-2.822l4.89 2.824Z"
    />
    <path
      fill="currentColor"
      d="M11.3 6.949a.8.8 0 0 0 1.399-.001l2.976-5.352a.798.798 0 0 0-.483-1.16 11.887 11.887 0 0 0-6.384 0 .802.802 0 0 0-.483 1.16l2.976 5.353Zm2.458-5.2L12 4.913 10.242 1.75a10.301 10.301 0 0 1 3.516 0Z"
    />
  </svg>
);
